import asjad_image from './Reviews/asjad.jpg'
import jp_image from './Reviews/jp.jpg'
import sujair_image from './Reviews/sujair.jpg'
import rasmy_image from './Reviews/rasmy.jpg'
import kanujan_image from './Reviews/kanujan.jpg'
import dilu_image from './Reviews/dilukshan.jpg'

const reviews = [
    {
        reviewer_name:"Asjad Ahamed",
        reviewer_city:"Aluthgama, Kalutara",
        reviewer_image:asjad_image ,
        review_about:"I can't get enough of Fusion Feast! The food is always fresh and delicious. The service is top-notch, and the ambiance is perfect for a cozy dinner. Their fish curry is a must-try!"
    },
    {
        reviewer_name:"Jeya Prashanth",
        reviewer_city:"Koppai, Jaffna",
        reviewer_image:jp_image ,
        review_about:"Fusion Feast is an absolute gem! The flavors are authentic and mouthwatering. I felt like I was transported to Sri Lanka with every bite. Highly recommend their curries and sambol!"
    },
    {
        reviewer_name:"Sujair Ibrahim",
        reviewer_city:"Malihakadu, Ampara",
        reviewer_image:sujair_image ,
        review_about:"Best Sri Lankan restaurant in town! The spices and flavors are spot on. I've tried almost everything on the menu, and I've never been disappointed. Their coconut roti and mutton curry are to die for!"
    },
    {
        reviewer_name:"Rasmy",
        reviewer_city:"Sammanthurai",
        reviewer_image: rasmy_image ,
        review_about:"Fusion Feast offers an incredible dining experience. The dishes are flavorful and beautifully presented. The staff is friendly and attentive. I highly recommend the string hoppers and chicken curry."
    },
    
    {
        reviewer_name:"DJ Dilukshan",
        reviewer_city:"Trincomalee",
        reviewer_image:dilu_image ,
        review_about:"Amazing food and great atmosphere! Fusion Feast has become my go-to spot for Sri Lankan cuisine. The flavors are rich and authentic. The lamb biryani and kottu roti are my favorites."
    },
    {
        reviewer_name:"Kanujan",
        reviewer_city:"Kilinochi",
        reviewer_image:kanujan_image ,
        review_about:"Fusion Feast exceeded my expectations! The food is flavorful and well-prepared. The restaurant has a warm and inviting ambiance. Their prawn curry and eggplant moju are simply outstanding."
    }
]

export default reviews